module.exports = __webpack_public_path__ + "static/media/50040.6a2fd333.png";